import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-visits',
  templateUrl: './visits.component.html',
  styleUrls: ['./visits.component.scss']
})
export class VisitsComponent implements OnInit {

  requestType : string = "visit";
  title : string = "الزيارات";
  
  constructor() { }

  ngOnInit() {
  }

}
